import { render, staticRenderFns } from "./PaymentScreenScanAndPay.vue?vue&type=template&id=47edeaaa&scoped=true&"
import script from "./PaymentScreenScanAndPay.vue?vue&type=script&lang=js&"
export * from "./PaymentScreenScanAndPay.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScreenScanAndPay.vue?vue&type=style&index=0&id=47edeaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47edeaaa",
  null
  
)

export default component.exports